var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLazyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1153 8.86254V10.942H12.5183V8.86254H20.1153ZM19.9675 2.47621L13.5904 10.942H11.8066V9.36162L18.156 0.942017H19.9675V2.47621ZM19.0248 0.942017V3.03074H11.9545V0.942017H19.0248Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.27387 19.9011V20.9419H0.471424V19.9011H4.27387ZM4.19986 16.7047L1.00802 20.9419H0.115234V20.1509L3.29319 15.9368H4.19986V16.7047ZM3.72802 15.9368V16.9822H0.189248V15.9368H3.72802Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8891 15.4421V16.8681H5.67942V15.4421H10.8891ZM10.7877 11.0627L6.4146 16.8681H5.19141V15.7843L9.54546 10.0106H10.7877V11.0627ZM10.1412 10.0106V11.443H5.29281V10.0106H10.1412Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLazyState);
export default __webpack_public_path__ + "static/media/lazy-state.9f1704e6931006880a6bd9d781b1ce6f.svg";
export { ForwardRef as ReactComponent };